import { useEffect, useState } from "react";
import { Tooltip } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

import styled from "styled-components";

import { InputErrorIcon } from "../../../../packages/SVGs";

import { colors, fontStyles } from "../../Theme";

import { combineClassNames } from "../../../../utils/appUtils";

const StyledTooltip = styled(Tooltip)`
  padding-left: ${({ type }) => (type === "error" ? "0 !important" : "auto")};

  .error {
    svg {
      padding-right: 5px !important;
      path {
        fill: white !important;
      }
    }
  }

  .tooltip-inner {
    max-width: ${({ maxWidth }) => maxWidth};
    background-color: ${({ type }) =>
      type === "error" ? "var(--du-color-red)" : colors.DefaultBackground};
    text-align: left;
    ${fontStyles.diodrum12}
    color: ${colors.White};

    ${({ type }) =>
      type === "error" &&
      `
        svg {
          margin-right: 5px !important;
              margin-bottom: 2px;
          path {
            fill: white !important;
            stroke: 1.5;
          }
        }
      `}
  }

  .tooltip-arrow::before {
    border-top-color: ${({ type }) =>
      type === "error"
        ? "var(--du-color-red)"
        : colors.DefaultBackground} !important;
  }
`;

const StyledOverlayTrigger = styled(OverlayTrigger)`
  border-radius: 2px;
  text-align: left;
`;

const CustomTooltip = ({
  text,
  children,
  type,
  className,
  placement = "top",
  forceShow = false,
  maxWidth = "200px",
}) => {
  const [show, setShow] = useState(true);
  const shouldForceShow = forceShow && Boolean(text);

  const renderTooltip = (isError) => (
    <StyledTooltip
      id="tooltip"
      type={type}
      className={combineClassNames("error", className)}
      maxWidth={maxWidth}
    >
      {isError && <InputErrorIcon />}
      {text}
    </StyledTooltip>
  );

  useEffect(() => setShow(Boolean(text)), [text]);

  return text ? (
    type === "error" ? (
      <StyledOverlayTrigger
        show={shouldForceShow ? true : show}
        placement="top-start"
        overlay={renderTooltip(true)}
        className="width-auto"
      >
        {children}
      </StyledOverlayTrigger>
    ) : (
      <StyledOverlayTrigger
        show={shouldForceShow ? true : undefined}
        placement={placement}
        overlay={renderTooltip()}
      >
        {children}
      </StyledOverlayTrigger>
    )
  ) : (
    children
  );
};

export default CustomTooltip;
